import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EditProductComponent } from '../edit-product.component';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import { map, debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { RepositoryService } from '../../../../../api/repository.service';
import { ProductRepoService } from '../../../../../api/productRepo.service';
import { ProductRepoTypeValueService } from '../../../../../api/productRepoTypeValue.service';

@Component({
  selector: 'meu-modal-choose-repository',
  templateUrl: './modal-choose-repository.component.html',
  styleUrls: ['./modal-choose-repository.component.scss'],
})
export class ModalChooseRepositoryComponent implements OnInit {
  listRepository = [];
  listlistRepositoryDataSearch = [];

  public controlSearch: FormControl = new FormControl();
  public keyUp = new Subject<KeyboardEvent>();
  dataSearchBasic: any = '';
  filter = '';
  totalPage = 0;
  page = 1;

  displayedColumns: string[] = ['index', 'name', 'code', 'address', 'leadtime', 'action'];
  totalRepository: any;
  pagesize = 10;
  pageIndex = 1;

  pageSizeOptions: number[] = [5, 10, 20, 100];

  itemRepository;

  listProductRepoIdDelete = [];
  listProductRepoPrivateIdDelete = [];

  constructor(
    public dialogRef: MatDialogRef<EditProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private toastr: ToastrService,
    private repositoryService: RepositoryService,
    private changeDetectorRef: ChangeDetectorRef,
    private productRepoService: ProductRepoService,
    private productRepoTypeValueService: ProductRepoTypeValueService
  ) {}

  ngOnInit() {
    this.keyUp
      .pipe(
        map((event) => event),
        debounceTime(300)
      )
      .subscribe((value) => {
        this.dataSearchBasic = value;
        this.filter = 'name@=*' + this.dataSearchBasic;
        this.page = 1;
        this.listlistRepositoryDataSearch = [];
        this.getListRepositoryDataSearch();
      });
    this.getListRepositoryDataSearch();

    if (this.data.listRepository.length > 0 && !this.data.isEdit) {
      this.listRepository = this.data.listRepository;
      this.totalRepository = this.data.listRepository.length;
    }

    if (this.data.productId && this.data.productId != '' && this.data.isEdit) {
      this.listRepository = [];
      this.loadProductRepositories();
    }

    if (this.data.type_value_id && this.data.type_value_id != '' && this.data.isEdit) {
      this.listRepository = [];
      this.loadProductRepoTypeValues();
    }
  }

  loadProductRepositories() {
    this.productRepoService
      .apiProductProductIDProductRepositoriesGet(
        this.data.productId,
        '',
        '',
        this.pageIndex,
        this.pagesize
      )
      .subscribe((res) => {
        if (res.success) {
          // this.pageIndex = res.data.pageIndex; // Tắt
          // this.pagesize = res.data.pagesize; // Tắt
          this.totalRepository = res.data.total;

          this.listRepository = res.data.collection.map((item) => ({
            id: item.repo_id,
            repo_id: item.repo_id,
            product_id: item.product_id,
            name: item.extend_repo_name,
            code: item.extend_repo_code,
            address: item.extend_repo_address,
            is_new: false,
            id_delete: item.id,
            quantity: item.quantity,
            SKUCode: item.sku,
            leadtime: item.leadtime || '',
            id_update: item.id,
          }));

          this.listRepository = [...this.listRepository];
        }
        this.changeDetectorRef.detectChanges();
      });
  }

  loadProductRepoTypeValues() {
    this.productRepoTypeValueService
      .apiProductRepoTypeValuesGet(
        'type_value_id==' + this.data.type_value_id,
        '',
        this.pageIndex,
        this.pagesize
      )
      .subscribe((res) => {
        if (res.success) {
          // this.pageIndex = res.data.pageIndex; // Tắt
          // this.pagesize = res.data.pagesize; // Tắt
          this.totalRepository = res.data.total;

          this.listRepository = res.data.collection.map((item) => ({
            id: item.repo_id,
            repo_id: item.repo_id,
            product_id: item.product_id,
            name: item.extend_repo_name,
            code: item.extend_repo_code,
            address: item.extend_repo_address,
            is_new: false,
            id_delete: item.id,
            quantity: item.quantity,
            SKUCode: item.sku,
            leadtime: item.leadtime || '',
            id_update: item.id,
          }));

          this.listRepository = [...this.listRepository];
        }
        this.changeDetectorRef.detectChanges();
      });
  }

  getListRepositoryDataSearch() {
    this.repositoryService.apiRepositoriesGet(this.filter, '', this.page, 10).subscribe((res) => {
      if (res.success) {
        this.totalPage = Math.ceil(res.data.total / 10);
        for (let i = 0; i < res.data.collection.length; i++) {
          let index = this.listlistRepositoryDataSearch.findIndex(
            (x) => x.id == res.data.collection[i].id
          );
          if (index == -1) {
            this.listlistRepositoryDataSearch.push({
              id: res.data.collection[i].id,
              repo_id: res.data.collection[i].id,
              name: res.data.collection[i].name,
              code: res.data.collection[i].code,
              address: res.data.collection[i].address,
              is_new: true,
              id_delete: '',
              quantity: 0,
              SKUCode: '',
              leadtime: '',
              id_update: '',
            });
          }
        }
      }
      this.changeDetectorRef.detectChanges();
    });
  }

  loadMore(e) {
    this.page = this.page + 1;
    this.getListRepositoryDataSearch();
  }

  search(event) {}

  deleteRepository(id) {
    if (this.data.productId && this.data.productId != '' && this.data.isEdit) {
      let item = this.listRepository.find((x) => x.id == id);
      if (item && !item.is_new) {
        this.listProductRepoIdDelete.push(item.id_delete);
      }
    }

    if (this.data.type_value_id && this.data.type_value_id != '' && this.data.isEdit) {
      let item = this.listRepository.find((x) => x.id == id);
      if (item && !item.is_new) {
        this.listProductRepoPrivateIdDelete.push(item.id_delete);
      }
    }

    let index = this.listRepository.findIndex((x) => x.id == id);
    if (index > -1) {
      this.listRepository.splice(index, 1);
      this.listRepository = [...this.listRepository];
      this.totalRepository = this.listRepository.length;
      this.changeDetectorRef.detectChanges();
    }
  }

  closeModal() {
    this.dialogRef.close({ event: false });
  }

  save() {
    let listWarehouseResult = this.listRepository;

    this.dialogRef.close({
      event: true,
      data: listWarehouseResult,
      listProductRepoIdDelete: this.listProductRepoIdDelete,
      listProductRepoPrivateIdDelete: this.listProductRepoPrivateIdDelete,
    });
  }

  addRepository() {
    if (!this.itemRepository) {
      this.toastr.warning('Vui lòng chọn một kho hàng');
      return;
    }

    let obj: any = this.itemRepository;
    obj['index'] = this.listRepository.length;

    let item = this.listRepository.find((x) => x.id == obj['id']);
    if (item) {
      this.toastr.warning('Kho hàng này đã được chọn');
      return;
    }

    this.listRepository.push(obj);
    this.listRepository = [...this.listRepository];
    this.totalRepository = this.listRepository.length;
    this.changeDetectorRef.detectChanges();
  }

  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndex = pageNumber;
      if (this.data.productId && this.data.productId != '' && this.data.isEdit) {
        this.loadProductRepositories();
      } else if (this.data.type_value_id && this.data.type_value_id != '' && this.data.isEdit) {
        this.loadProductRepoTypeValues();
      }
    }
  }

  onPageSizeChange(newSize: number) {
    this.pagesize = newSize;
    this.pageIndex = 1;
    if (this.data.productId && this.data.productId != '' && this.data.isEdit) {
      this.loadProductRepositories();
    } else if (this.data.type_value_id && this.data.type_value_id != '' && this.data.isEdit) {
      this.loadProductRepoTypeValues();
    }
  }
}
